import React, { useEffect, useState } from 'react';
import { round  } from '../makeitwork/weather'; 
import { DateTime } from 'luxon';
import {
    UilTear,
    UilWind,
    UilArrowUp,
    UilArrowDown,
  } from "@iconscout/react-unicons";
function Daily({h, currentFormattedData ,temperatureUnit}) {
  const [icons, setIcons] = useState([]);
  useEffect(() => {
    const theicon = {
      night113: "falling-stars",
      night116: "partly-cloudy-night",
      night119: "overcast-night",
      night122: "overcast",
      night143: "partly-cloudy-night-fog",
      night176: "overcast-night-rain",
      night179: "overcast-night-snow",
      night182: "overcast-night-sleet",
      night185: "overcast-fog",
      night200: "thunderstorms-night-extreme",
      night227: "sleet",
      night230: "overcast-snow",
      night248: "partly-cloudy-night-fog",
      night260: "partly-cloudy-night-haze",
      night263: "overcast-night-drizzle",
      night266: "overcast-night-drizzle",
      night281: "overcast-haze",
      night284: "overcast-fog",
      night293: "overcast-night-rain",
      night296: "overcast-rain",
      night299: "overcast-night-rain",
      night302: "overcast-rain",
      night305: "overcast-night-rain",
      night308: "overcast-rain",
      night311: "overcast-haze",
      night314: "overcast-haze",
      night317: "overcast-sleet",
      night320: "overcast-sleet",
      night323: "overcast-night-sleet",
      night326: "overcast-snow",
      night329: "overcast-night-sleet",
      night332: "overcast-snow",
      night335: "overcast-night-sleet",
      night338: "overcast-snow",
      night350: "overcast-smoke",
      night353: "overcast-night-rain",
      night356: "overcast-night-rain",
      night359: "extreme-night-rain",
      night362: "overcast-night-sleet",
      night365: "overcast-night-sleet",
      night368: "overcast-snow",
      night371: "overcast-snow",
      night374: "overcast-smoke",
      night377: "overcast-smoke",
      night386: "thunderstorms-night-extreme",
      night389: "thunderstorms-extreme",
      night392: "thunderstorms-night-extreme-snow",
      night395: "thunderstorms-extreme-snow",
      //day
      day113: "clear-day",
      day116: "partly-cloudy-day",
      day119: "overcast-day",
      day122: "overcast",
      day143: "partly-cloudy-day-fog",
      day176: "overcast-day-rain",
      day179: "overcast-day-snow",
      day182: "overcast-day-sleet",
      day185: "overcast-fog",
      day200: "thunderstorms-day-extreme",
      day227: "sleet",
      day230: "overcast-snow",
      day248: "partly-cloudy-day-fog",
      day260: "partly-cloudy-day-haze",
      day263: "overcast-day-drizzle",
      day266: "overcast-day-drizzle",
      day281: "overcast-haze",
      day284: "overcast-fog",
      day293: "overcast-day-rain",
      day296: "overcast-rain",
      day299: "overcast-day-rain",
      day302: "overcast-rain",
      day305: "overcast-day-rain",
      day308: "overcast-rain",
      day311: "overcast-haze",
      day314: "overcast-haze",
      day317: "overcast-sleet",
      day320: "overcast-sleet",
      day323: "overcast-day-sleet",
      day326: "overcast-snow",
      day329: "overcast-day-sleet",
      day332: "overcast-snow",
      day335: "overcast-day-sleet",
      day338: "overcast-snow",
      day350: "overcast-smoke",
      day353: "overcast-day-rain",
      day356: "overcast-day-rain",
      day359: "extreme-day-rain",
      day362: "overcast-day-sleet",
      day365: "overcast-day-sleet",
      day368: "overcast-snow",
      day371: "overcast-snow",
      day374: "overcast-smoke",
      day377: "overcast-smoke",
      day386: "thunderstorms-day-extreme",
      day389: "thunderstorms-extreme",
      day392: "thunderstorms-day-extreme-snow",
      day395: "thunderstorms-extreme-snow",
    };  
    const iconsPromises = currentFormattedData.forecast.forecastday.map((dayItem) => {
      const currentIcon = dayItem.day.condition.icon.split('/').slice(-2).join('').replace('.png', '');
      const iconSrc = theicon[currentIcon];
      return import(`../svg/${iconSrc}.svg`).then((module) => module.default);
    });

    Promise.all(iconsPromises)
      .then((loadedIcons) => setIcons(loadedIcons))
      .catch((error) => console.error(`Failed to load SVG icons: ${error.message}`));
  }, [currentFormattedData.forecast.forecastday]);

    return (
      <div className='mx-3'>
          <div className="flex items-center justify-stat mt-6">
            <p className="text-white font-medium uppercase">{h}</p>
          </div>
          <hr className="my-2"></hr>
          <div className="flex flex-row items-center justify-start text-white details-scroll-container overflow-x-auto relative ">
            {currentFormattedData.forecast.forecastday.map((dayItem, index) => {
              const date = DateTime.fromISO(dayItem.date);
            
              return (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center mx-2"
                  style={{ backgroundColor: 'rgb(255, 255, 255, 0.2)', borderRadius: '8px' }}
                >
                  <p className="font-light text-sm">{date.toFormat('cccc')}</p>
                  <img src={icons[index]} className='w-40 h-20' alt="Weather Icon" />                          
                  <div className="font-light text-sm flex flex-row ">
                    <div className='flex flex-row items-center '>
                      <UilArrowUp size={18} />
                      {temperatureUnit === 'Celsius' ? round(dayItem.day.maxtemp_c) : round(dayItem.day.maxtemp_f)}°
                    </div>,
                    <div className='flex flex-row items-center '>
                      <UilArrowDown size={18} /> 
                      {temperatureUnit === 'Celsius' ? round(dayItem.day.mintemp_c) : round(dayItem.day.mintemp_f)}°
                   </div>
                  </div>
                  <div className="font-light text-sm flex flex-row items-center justify-center mx-2">
                   
                      <div className='flex flex-row items-center '>
                      <UilTear size={18} />                        
                      {round(dayItem.day.avghumidity)}<span className=" text-xs">%</span>
                      </div>,
                      <div className='flex flex-row items-center '>
                          <UilWind size={18} />                      
                          {temperatureUnit === 'Celsius' 
                              ? <span>{round(dayItem.day.maxwind_kph)}<span className="text-xs">Kph</span></span>
                              : <span>{round(dayItem.day.maxwind_mph)}<span className="text-xs">Mph</span></span>
                          }
                      </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );

}  
export default Daily;